export default __webpack_public_path__ + "static/media/Transparency-seal-circle-300x300.eeef8481.png";